import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=4151c898"
import script from "./Bulletin.vue?vue&type=script&lang=js"
export * from "./Bulletin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports